import { useState } from "react";
import { Link } from "react-router-dom";
import { Phone, Menu, X, Lock } from "lucide-react";
import { BRAND, LOGO } from "@/lib/brand";

const NAV = [["#servizi", "Servizi"], ["#listino", "Listino"], ["#prenota", "Prenota ritiro"], ["/cimitero", "Cimitero virtuale"], ["/app", "Scarica l'app"], ["#contatti", "Contatti"]];

export const SiteHeader = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 bg-[#FAF8F5]/85 backdrop-blur-xl border-b border-[#E2DDD5]/70">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between gap-4">
        <Link to="/" data-testid="header-logo-link" className="shrink-0">
          <img src={LOGO} alt={BRAND.name} className="h-10 sm:h-12 w-auto" />
        </Link>
        <nav className="hidden lg:flex items-center gap-8 text-sm font-medium text-[#1C2A33]">
          {NAV.map(([h, l]) => (
            <a key={h} href={h} className="hover:text-[#B8860B] transition-colors" data-testid={`nav-${h.replace(/[#/]/, "")}`}>{l}</a>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          <a href={BRAND.phoneHref} data-testid="header-call-button" className="inline-flex items-center gap-2 rounded-full border border-[#0D3B52]/20 px-4 py-2 text-sm font-semibold text-[#0D3B52] hover:border-[#D4AF37] transition-colors">
            <Phone className="h-4 w-4" /> {BRAND.phone}
          </a>
          <Link to="/login" data-testid="header-login-button" className="inline-flex items-center gap-2 rounded-full bg-[#0D3B52] px-5 py-2 text-sm font-semibold text-white hover:bg-[#082535] transition-colors">
            <Lock className="h-4 w-4" /> Area riservata
          </Link>
        </div>
        <button className="lg:hidden p-2 text-[#0D3B52]" onClick={() => setOpen(!open)} data-testid="header-mobile-menu-button" aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-[#E2DDD5] bg-[#FAF8F5] px-5 py-4 space-y-3">
          {NAV.map(([h, l]) => (
            <a key={h} href={h} onClick={() => setOpen(false)} className="block py-1 text-[#0D3B52] font-medium">{l}</a>
          ))}
          <a href={BRAND.phoneHref} className="block py-1 text-[#0D3B52] font-semibold">Chiama {BRAND.phone}</a>
          <Link to="/login" data-testid="mobile-login-link" className="block rounded-full bg-[#0D3B52] text-white text-center py-2.5 font-semibold">Area riservata</Link>
        </div>
      )}
    </header>
  );
};
